import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { MatLegacyRadioChange as MatRadioChange } from "@angular/material/legacy-radio";
import { includes } from "lodash-es";

import { CommunicationMethod } from "../../../sdk";
import { BUTTONS, COMMUNICATION_CHANNELS } from "../suspicious-login.const";

@Component({
	selector: "obg-m-suspicious-login-request-code",
	templateUrl: "./suspicious-login-request-code.component.html",
	styleUrls: ["./suspicious-login-request-code.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SuspiciousLoginRequestCodeComponent {
	@HostBinding("class.obg-m-suspicious-login-request-code") hostCssClass = true;

	@Input() showErrorMessage: boolean | undefined;
	@Input() buttonText: string | undefined;
	@Input() communicationMethods: CommunicationMethod[] | undefined;

	@Output() submit = new EventEmitter<string>();

	selectedChannel: string | undefined;

	onSelectionChange(change: MatRadioChange) {
		this.buttonText = includes(COMMUNICATION_CHANNELS, change.value) ? BUTTONS.sendCode : BUTTONS.continue;
	}

	methodTrackBy(_index: string, method: CommunicationMethod): string {
		return method.channel;
	}
}
